import * as React from 'react';
import {injectIntl} from 'react-intl';
import {ToastType} from "../../stores/ui-state.store";
import {Snackbar} from "@material-ui/core";
import {createStyles, makeStyles} from "@material-ui/styles";

interface OwnProps {
    toastType?: ToastType;
    color?: string;
    message?: string;
    show: boolean;
    onClose: () => void;
    duration?: number;

}

type Props = OwnProps;

const useStyles = makeStyles((props: Props) =>
    createStyles({
        root: {
            position: 'relative',
            width: '100%',
            height: 'calc(100%-40px)',
            overflow: 'hidden',
            margin: '20px',
            borderRadius: '4px',
            boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.2), ' +
                '0 2px 1px -1px rgba(0, 0, 0, 0.12), ' +
                '0 1px 1px 0 rgba(0, 0, 0, 0.14)',
            backgroundColor: '#fafafa',
        },
        successToast: {
            display: 'flex',
            justifyContent: 'center',
            backgroundColor: props.color || '#43a047',
        },
        errorToast: {
            display: 'flex',
            justifyContent: 'center',
            backgroundColor: props.color || '#d32e30',
        },
    }),
);

const ToastSnackBar = (props: Props) => {
    const classes = useStyles(props);
    const { show, onClose, duration } = props;
    let className;
    if (props.toastType === ToastType.ERROR) {
        className = classes.errorToast;
    } else if (props.toastType === ToastType.SUCCESS) {
        className = classes.successToast;
    }
    return (
        <div className={classes.root}>
            <Snackbar
                autoHideDuration={duration || 3000}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                open={show}
                onClose={onClose}
                message={show && props.message}
                ContentProps={{ className: className }}
            />
        </div>
    );
};

export default (injectIntl(ToastSnackBar));
